module.exports = {
    locales: ["pt-br"],
    termsOptId:'152_04',
    termsOptText:'Termos e Política de Privacidade. Você tem no mínimo 18 anos, leu e concorda com os Termos e Condições da P&G e Política de Privacidade. Para melhor adequar nossas comunicações às suas necessidades, combinaremos os dados.',
    emailOptId:"152_01",
    emailOptText:'Eu quero receber e-mails, ofertas e cupons de Pantene e outras marcas P&G confiáveis.',
    emailOptDomId:'globalOpt_optStatus2'


};
